import { Tag } from "../Tag/Tag";
import "../Tags.scss";

type TagsProps = {
  topics?: Array<string>;
};

export const TagsGroup = ({ topics = [] }: TagsProps) => {
  return (
    <div className="tags-group-container">
      <div className="tags-group">
        {topics.map((topic, index) => (
          <Tag key={index} label={topic} />
        ))}
      </div>
    </div>
  );
};
